import {useEffect} from "react";
import {Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import Countdown from "react-countdown";
import {useNavigate} from "react-router-dom";
import {useDailyRaces} from "../../../features/bulletin/bulletin.store";
import {homeHippodrome, homeHippodromeSubject} from "../../../store/misc.store";
import {MutualBetslip} from "../../../features/betslip/mutual.service";
import paths from "../../../paths";
import weatherIcon from "../../../assets/icons/home/weather-partly-cloudy.png";
import humidityIcon from "../../../assets/icons/home/weather-humidity.png";

export function selectHomeHippodrome(hippodrome: any) {
    if (!hippodrome || homeHippodrome?._id === hippodrome._id) {
        return;
    }
    Object.assign(homeHippodrome, hippodrome);
    homeHippodromeSubject.next(hippodrome);
    MutualBetslip.setOptions({hippodrome});
}

export function HippodromeCards() {
    const dailyRaces = useDailyRaces();
    const navigate = useNavigate();

    const hippodromes = dailyRaces.filter((hippodrome: any) => hippodrome.card_id != null);

    useEffect(() => {
        if (!homeHippodrome?._id) {
            selectHomeHippodrome(hippodromes.find((el: any) => el.nextRun) ?? hippodromes[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hippodromes]);

    if (hippodromes.length === 0) {
        return null;
    }

    const activeIndex = Math.max(0, hippodromes.findIndex((el: any) => el._id === homeHippodrome?._id));

    return <div className={"hippodrome-panel"}>
        <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            spaceBetween={12}
            initialSlide={activeIndex}
            pagination={{clickable: true, el: ".hippodrome-panel-dots"}}
            onSlideChange={(swiper: any) => selectHomeHippodrome(hippodromes[swiper.activeIndex])}
        >
            {hippodromes.map((hippodrome: any, index: number) => {
                const nextRun = hippodrome.nextRun;
                const lastRun = hippodrome.runs?.[hippodrome.runs.length - 1];
                const finishedRuns = hippodrome.runs?.filter((run: any) => run.status !== 0) ?? [];
                const lastFinishedRun = finishedRuns[finishedRuns.length - 1];
                const slug = (hippodrome.keyword + hippodrome._id).toLowerCase();
                const keyword = hippodrome.keyword.toLowerCase();
                const runNo = nextRun?.no ?? lastRun?.no ?? 1;
                const resultRunNo = lastFinishedRun?.no ?? 1;
                return <SwiperSlide key={`hippodrome-card-${index}`}>
                    <div className={"hippodrome-card"}>
                        <div className={"hippodrome-card-main"}>
                            <h3 className={"hippodrome-card-title"}>{hippodrome.hippodrome}</h3>
                            <span className={"hippodrome-card-status"}>
                                {nextRun ? <>
                                    {nextRun.no}. Koşu · {nextRun.time} - <Countdown
                                    date={nextRun.running_date}
                                    renderer={({hours, minutes, seconds, completed}) => completed
                                        ? <>Başlamak Üzere</>
                                        : <>{hours.toString().padStart(2, "0")}:{minutes.toString().padStart(2, "0")}:{seconds.toString().padStart(2, "0")}</>}
                                /></> : <>Koşular Tamamlandı</>}
                            </span>
                            <button className={"hippodrome-card-cta"} onClick={() => {
                                selectHomeHippodrome(hippodrome);
                                navigate(`${paths.betting.url}/${(hippodrome.keyword + hippodrome._id).toLowerCase()}`);
                            }}>Bahis Yap
                            </button>
                        </div>
                        {hippodrome.weather && <div className={"hippodrome-weather"}>
                            <div className={"hippodrome-weather-head"}>
                                <div>
                                    <strong>{hippodrome.weather.temperature || "-"}<sup>°C</sup></strong>
                                    <span>{hippodrome.weather.forecast}</span>
                                </div>
                                <img src={weatherIcon} alt={""}/>
                            </div>
                            <div className={"hippodrome-weather-metrics"}>
                                <div>
                                    <img src={humidityIcon} alt={""}/>
                                    <span>{hippodrome.weather.humidity ? `%${hippodrome.weather.humidity}` : "-"}</span>
                                </div>
                            </div>
                        </div>}
                    </div>
                    <div className={"hippodrome-card-links"}>
                        <button onClick={() => {
                            selectHomeHippodrome(hippodrome);
                            navigate(`${paths.possibles.url}/${slug}/${runNo}`);
                        }}>Muhtemeller
                        </button>
                        <button onClick={() => {
                            selectHomeHippodrome(hippodrome);
                            navigate(`${paths.agf.url}/${keyword}/${runNo}`);
                        }}>AGF'ler
                        </button>
                        <button onClick={() => {
                            selectHomeHippodrome(hippodrome);
                            navigate(`${paths.results.url}/${keyword}/${resultRunNo}`);
                        }}>Sonuçlar
                        </button>
                    </div>
                </SwiperSlide>
            })}
        </Swiper>
        <div className={"hippodrome-panel-dots"}></div>
    </div>;
}
